export function uploadImage(event: any) {
    const filename = URL.createObjectURL(event.target!.files[0]);
    const preview = document.querySelector('#preview')!;
    const img = document.createElement('img');
    img.setAttribute('src', filename);
    preview.innerHTML = '';
    preview.appendChild(img);
}